import { defineMessages } from 'react-intl'

import { TYPE } from './constants'

export const typeMessages = defineMessages({
  [TYPE.BASE]: {
    id: 'spanish.inventories.types.base',
    defaultMessage: 'Base'
  },
  [TYPE.WAREHOUSE]: {
    id: 'spanish.inventories.types.warehouse',
    defaultMessage: 'Bodega'
  },
  [TYPE.CART]: {
    id: 'spanish.inventories.types.cart',
    defaultMessage: 'Carrito'
  }
})
